import PickingSupplyForSubcontractDetail from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontractDetail';

export default class PickingSupplyForSubcontractDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingSupplyForSubcontractId  = '';
		this.pickingSupplyForSubcontractPickingSupplyForSubcontractNumber = '';
		this.workOrderSupplyForSubconDetailId  = '';
		this.workOrderSupplyForSubconDetailPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.supplyQty = '';
		this.actualQty = '';
		this.isCompleted = false;
		this.processById  = '';
		this.processByFirstName = '';
		this.processDateFrom = '';
		this.processDateTo = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.showIsCompleteType = '';
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingSupplyForSubcontractId : '0',
			pickingSupplyForSubcontractPickingSupplyForSubcontractNumber : '0',
			workOrderSupplyForSubconDetailId : '0',
			workOrderSupplyForSubconDetailPart : '0',
			partId : '0',
			partPartNumber : '0',
			supplyQty : '0',
			actualQty : '0',
			isCompleted : '0',
			processById : '0',
			processByFirstName : '0',
			processDateFrom : '0',
			processDateTo : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}